<app-dialog-header label="Denuncias de tráfico"></app-dialog-header>
<form #mainForm>
  <div class="row" style="text-align: center;">
    <app-form-date-edit class="col" label="Fecha límite descuento" i18n-label [(value)]="this.fecha"></app-form-date-edit>
  </div>
  <button class="btn btn-primary "(click)="Continuar()">Continuar</button>
</form>
